// ORDER STATUS KEYS (match backend)

export const ORDER_STATUS_KEYS = {
  RECEIVED: 'received',
  SENT: 'sent',
  DISPATCHED: 'dispatched',
  BILLED: 'billed',
  CANCELLED: 'cancelled',
  TO_BE_BILLED: 'tobebilled',
  ON_THE_WAY: 'ontheway',
  PARTIAL: 'partial',
  ANNULLED: 'annulled'
}

// STATUS UI MAP

export const ORDER_STATUS_UI_MAP = {
  received: { label: 'RECIBIDO', className: 'received-style' },
  sent: { label: 'ENVIADO', className: 'sent-style' },
  dispatched: { label: 'DESPACHADO', className: 'dispatched-style' },
  billed: { label: 'FACTURADO', className: 'billed-style' },
  cancelled: { label: 'CANCELADO', className: 'cancelled-style' },
  tobebilled: { label: 'POR FACTURAR', className: 'pending-bill-style' },
  ontheway: { label: 'EN CAMINO', className: 'dispatched-style' },
  partial: { label: 'PARCIAL', className: 'partial-style' },
  annulled: { label: 'ANULADO', className: 'annulled-style' }
}

// TAB VALUES

export const ORDER_TAB_VALUES = {
  ORDER: 'order',
  SALES_ORDER: 'sales_order'
}

// TAB BUILDER (dinámico)

export const buildOrderTabs = (invoiceApp = [], hasSalesOrder = false) => {
  const tabs = [
    {
      value: ORDER_TAB_VALUES.ORDER,
      label: 'Pedido',
      icon: 'shopping_cart',
      iconSize: 20,
      filled: true
    }
  ]

  if (hasSalesOrder) {
    tabs.push({
      value: ORDER_TAB_VALUES.SALES_ORDER,
      label: 'Pedido ERP',
      icon: 'receipt_long',
      iconSize: 20,
      filled: true
    })
  }

  invoiceApp?.forEach((_, index) => {
    tabs.push({
      value: `invoice-${index}`,
      label: `Factura-${index + 1}`,
      icon: 'receipt',
      iconSize: 20,
      filled: true
    })
  })

  return tabs
}

// HEADER CONFIG

export const ORDER_HEADER_CONFIG = {
  titleKey: 'client_name',
  cards: [
    {
      icon: 'barcode_scanner',
      label: 'Código:',
      valueKey: 'client_db_ref'
    },
    {
      icon: 'account_box',
      label: 'Vendedor:',
      valueKey: 'salesman_name',
      filled: true
    },
    {
      icon: 'event',
      label: 'Fecha de creación:',
      valueKey: 'created_date',
      format: 'date'
    }
  ]
}


export const INVOICE_HEADER_CONFIG = {
  titleKey: 'client_name',
  cards: [
    {
      icon: 'barcode_scanner',
      label: 'Código:',
      valueKey: 'client_db_ref'
    },

    {
      icon: 'event',
      label: 'Fecha de creación:',
      valueKey: 'created_date',
      format: 'date'
    }
  ]
}

export const SALES_ORDER_HEADER_CONFIG = {
  titleKey: 'client_name',
  cards: [
    {
      icon: 'barcode_scanner',
      label: 'Código:',
      valueKey: 'client_uid'
    },
    {
      icon: 'account_box',
      label: 'Vendedor:',
      valueKey: 'user_full_name',
      filled: true
    },
    {
      icon: 'event',
      label: 'Fecha de creación:',
      valueKey: 'created_at',
      format: 'date'
    }
  ]
}
